import { createSlice } from '@reduxjs/toolkit'

/*
* user intial state
*/
const initialState = {
  sidebar: false
}

/*
* Slice
*/
const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    toggleSidebar: (state, action) => {
      state.sidebar = !state.sidebar;
    }
  },
});

export const {
  toggleSidebar
} = slice.actions

export default slice.reducer
